import script from "./PreSportsFixtureBook.vue?vue&type=script&setup=true&lang=js"
export * from "./PreSportsFixtureBook.vue?vue&type=script&setup=true&lang=js"

import "./PreSportsFixtureBook.vue?vue&type=style&index=0&id=02dd5889&scoped=true&lang=css"
import "./PreSportsFixtureBook.vue?vue&type=style&index=1&id=02dd5889&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-02dd5889"]])

export default __exports__